import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshfest';

export default function Example() {
  return (
    <>
      <Head>
        <title>PoshFest 2021 - All about it and what to expect</title>
        <meta name='description' content='Your guide to this year’s Poshmark annual conference.' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshfest' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshfest' />
        <meta property='og:title' content='PoshFest 2021 - All about it and what to expect' />
        <meta property='og:description' content='Your guide to this year’s Poshmark annual conference.' />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-07-23T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-07-23T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
